import React, { useState, useEffect } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";
import { Spin, PageHeader } from "antd";

import { Table } from "../../components";
import { getUrl, requests } from "../../globals/requests";
import {
  Container,
  SpaceBetween,
  TableContainer,
  TableButtonsContainer,
} from "./styles";
import { helpers } from "../../utils";
import { investmentColumns } from "./helpers";

function UserInvestments(props) {
  const [investments, setInvestments] = useState([]);
  const [investmentsBuff, setInvestmentsBuff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buff, setBuff] = useState({});

  const history = useHistory();
  const user = history?.location?.state?.user;
  let { userId } = useParams();

  useEffect(() => {
    async function getInvestments() {
      try {
        const url = getUrl("investments");
        setLoading(true);
        const query = { userId };
        const response = await requests.getWithAuth(url, query);
        setLoading(false);
        setInvestments(response.data);
        setInvestmentsBuff(response.data);
      } catch (e) {
        setLoading(false);
        helpers.displayMessage(e);
      }
    }

    getInvestments();
  }, [userId]);

  function filterInvestments(e) {
    const searchValue = e.target.value;
    if (searchValue === "") {
      setInvestments(investmentsBuff);
      return;
    }

    if (buff[searchValue]) {
      setInvestments(buff[searchValue]);
    } else {
      const filteredSavers = investments.filter((el) => {
        const inFirstName = el.userId.first_name
          .toLowerCase()
          .includes(searchValue.toLowerCase());
        const inLastName = el.userId.last_name
          .toLowerCase()
          .includes(searchValue.toLowerCase());
        const inPlanName = el.name
          .toLowerCase()
          .includes(searchValue.toLowerCase());

        const inPlanType = el.type
          .toLowerCase()
          .includes(searchValue.toLowerCase());
        return inFirstName || inLastName || inPlanName || inPlanType;
      });
      setInvestments(filteredSavers);
      setBuff({ ...buff, [searchValue]: filteredSavers });
    }
  }

  if (loading) {
    return (
      <div className="spin-contain">
        <Spin delay={100} size="large" tip="Getting Users..."></Spin>
      </div>
    );
  }

  return (
    <Container>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title="Back"
        subTitle={`${
          user.first_name + " " + user.last_name
        }'s Investments Plan`}
      />
      <TableButtonsContainer>
        <SpaceBetween>
          <div className="org-inpup-container">
            <Input
              size="large"
              onChange={filterInvestments}
              placeholder="Search by name, plan or plan type"
              prefix={<SearchOutlined />}
            />
          </div>
        </SpaceBetween>
      </TableButtonsContainer>

      <TableContainer>
        <Table columns={investmentColumns} dataSource={investments} />
      </TableContainer>
    </Container>
  );
}

export default UserInvestments;
